import { Button } from "@chakra-ui/react";
import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { FiChevronRight } from "react-icons/fi";
import { FocusOverlay } from "../../../../common/focus/FocusOverlay";
import { FocusSubjectList } from "../../../../common/focus/FocusSubjectList";
import type { FocusProgress, FocusSubject } from "../../../../common/focus/focusSubject";

interface Props {
  eyebrow: string;
  subtitle?: string;
  subjects: FocusSubject[];
  active: FocusSubject;
  index: number;
  progress: FocusProgress;
  hasPrevious: boolean;
  hasNext: boolean;
  onSelect: (id: string) => void;
  onPrevious: () => void;
  onNext: () => void;
  onClose: () => void;
  renderContent: (subject: FocusSubject) => ReactNode;
  renderActions: (subject: FocusSubject) => ReactNode;
}

export const BidFocusOverlay = ({
  eyebrow,
  subtitle,
  subjects,
  active,
  index,
  progress,
  hasPrevious,
  hasNext,
  onSelect,
  onPrevious,
  onNext,
  onClose,
  renderContent,
  renderActions,
}: Props) => {
  const { t } = useTranslation();

  return (
    <FocusOverlay
      eyebrow={eyebrow}
      title={active.title}
      subtitle={subtitle}
      position={{ current: index + 1, total: subjects.length }}
      onPrevious={onPrevious}
      onNext={onNext}
      hasPrevious={hasPrevious}
      hasNext={hasNext}
      previousLabel={String(t("Previous supplier"))}
      nextLabel={String(t("Next supplier"))}
      onClose={onClose}
      scrollResetKey={active.id}
      listPanel={
        <FocusSubjectList
          heading={String(t("Suppliers"))}
          subjects={subjects}
          activeId={active.id}
          onSelect={onSelect}
          progress={progress}
        />
      }
      footerStart={renderActions(active)}
      footerEnd={
        <Button rightIcon={<FiChevronRight />} onClick={onNext} isDisabled={!hasNext}>
          {t("Next supplier")}
        </Button>
      }
    >
      {renderContent(active)}
    </FocusOverlay>
  );
};
